import styled from 'styled-components';
import whiteCheckMark from 'assets/images/check-mark-white.svg';

const CheckBoxField = styled.label`
  display: inline-flex;
  align-items: center;
  width: 100%;
  &:hover {
    cursor: ${p => p.disabled ? 'default' : 'pointer'};
  }
`;

const checkBoxBorderColor = p => {
  let color = p.theme.color.border;
  if (p.checked) {
    color = p.theme.color.primary;
  }
  if (p.error) {
    color = p.theme.color.error;
  }
  if (p.disabled) {
    color = p.theme.color.disabled;
  }
  return color;
};

const checkBoxBgColor = p => {
  if (p.disabled) { return p.theme.color.disabled; }
  if (p.checked) { return p.theme.color.primary; }
  if (p.error) { return p.theme.color.error; }
  return p.theme.color.bg_white;
};

const CheckBoxWrapper = styled.div`
  width: 18px;
  height: 18px;
  margin-right: 20px;
  border-radius: 3px;
  border: 1px solid;
  align-items: center;
  justify-content: center;
  border-color: ${p => checkBoxBorderColor(p)};
  background-color: ${p => (checkBoxBgColor(p))};
  background-image:  ${p => (p.checked && `url(${whiteCheckMark})`)} ;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 80%;
  > input {
    position: 'absolute';
    opacity: 0;
    width: 0;
    height: 0;
    z-index: -1;
  }
`;

const RightTextLabel = styled.span`
  color: ${p => p.disabled ? p.theme.color.label : 'inherit'};
  font-size: 15px;
  flex: 1;
  max-width: 225px;
`;

export { CheckBoxField, CheckBoxWrapper, RightTextLabel };
